import React from 'react';
import { useMarkingContext } from '../MarkingContext/MarkingContext';
import { Box, Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ButtonStartIcon from '../../../../../button/ButtonStartIcon';
import { useNavigate } from 'react-router-dom';

const ListInfo = () => {
  const navigate = useNavigate();
  const { currentPeriodicalReport, loading } = useMarkingContext();

  return (
    <div className='flex items-center justify-center h-full '>
      <Box className='py-4 px-6 flex flex-col items-center gap-4 justify-center border-2 border-dashed border-muted rounded-lg'>
        <FontAwesomeIcon icon={['fas', 'empty-set']} className='text-muted text-8xl text-center' />
        <Typography
          align='center'
          variant='inherit'
          className='text-muted-foregroud opacity-25 font-bold uppercase text-2xl'
        >
          Data not available{' '}
        </Typography>
        <Typography align='center' variant='inherit' className='text-muted-foregroud opacity-50 text-lg'>
          You must go to the assessment areas settings to generate a preview
        </Typography>
        <div>
      {currentPeriodicalReport?.status === 'draft' && (
        <ButtonStartIcon
          disabled={loading}
          onClick={() =>
            navigate(`/dashboard/periodical-report/edit/${currentPeriodicalReport?._id}/assessment-area`)
          }
          startIcon={'cog'}
          color='primary'
          className='max-w-150px'
        >
          assessment areas settings
        </ButtonStartIcon>
      )}
    </div>
      </Box>
    </div>
  );
};

export default ListInfo;
